export default function ShippingAndDeliveryPolicy() {
    return (
        <div className="policy-page">
            <div className="policy-header">
                <h1>Shipping & Delivery Policy</h1>
                <p>Information about shipping and delivery.</p>
            </div>

            <div className="policy-content">
                <h2>1. Shipping</h2>
                <p>
                    We currently ship products across India.
                </p>

                <h2>2. Shipping Timeline</h2>
                <ul>
                    <li>
                        Orders are usually dispatched within <strong>2–5 working days</strong>.
                    </li>
                    <li>
                        Delivery times range from <strong>5–12 business days</strong>,
                        depending on the delivery location.
                    </li>
                </ul>

                <h2>3. Shipping Charges</h2>
                <p>
                    Shipping charges, if applicable, will be displayed at checkout
                    before payment is completed.
                </p>

                <h2>4. Tracking</h2>
                <p>
                    Customers will receive a tracking ID once their order has been
                    dispatched.
                </p>

                <h2>5. Software Terms & Delivery</h2>

                <ul>
                    <li>
                        सदर सॉफ्टवेअर हे एका संगणकासाठी व एक वर्षासाठीच असेल.
                    </li>

                    <li>
                        हार्डवेअर नंबर बदलल्यास कोणत्याही प्रकारची सेवा दिली जाणार नाही.
                    </li>

                    <li>
                        सॉफ्टवेअर इंस्टॉल केल्यानंतर संगणक खराब झाल्यास त्याबदल्यात
                        दुसऱ्या संगणकावर ते इंस्टॉल करून दिले जाणार नाही. त्यासाठी पुन्हा
                        पूर्ण रक्कम भरावी लागेल.
                    </li>

                    <li>
                        पैसे भरल्यानंतर सॉफ्टवेअर इंस्टॉल करण्यासाठी <strong>५ ते ७ दिवस</strong>
                        लागू शकतात.
                    </li>

                    <li>
                        सदर सॉफ्टवेअर हे पूर्णतः विंडोज-बेस्ड आहे.
                    </li>

                    <li>
                        सॉफ्टवेअर ऑनलाइन इंस्टॉल करून दिले जाईल.
                    </li>

                    <li>
                        सॉफ्टवेअरची रक्कम भरण्यापूर्वी खालील क्रमांकावर कॉल करावा:
                        <strong> 9922815978</strong>
                    </li>
                </ul>

                <h2>6. Delivery Issues</h2>
                <p>
                    For any delivery-related concerns, including delayed, damaged, or
                    otherwise affected orders, please contact our support team.
                </p>

                <h2>7. Contact</h2>
                <p>
                    For shipping, delivery, or software installation-related questions,
                    please contact us at:
                </p>

                <p>
                    <strong>Phone:</strong>{" "}
                    <a href="tel:9922815978">9922815978</a>
                </p>

                <p>
                    <strong>Email:</strong>{" "}
                    <a href="mailto:gorelearning.crm@gmail.com">
                        gorelearning.crm@gmail.com
                    </a>
                </p>
            </div>
        </div>
    );
}